export const languages = [
    "Cn",
    "En",
    "Ru",
]